import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloseIcon from "@mui/icons-material/Close";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import EventIcon from "@mui/icons-material/Event";
import FacebookIcon from "@mui/icons-material/Facebook";
import HomeIcon from "@mui/icons-material/Home";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from "@mui/icons-material/People";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import ScheduleIcon from "@mui/icons-material/Schedule";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import DownloadIcon from "@mui/icons-material/Download";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RegistrationGuidelines from "../image/Registration_Guidelines.pdf";
import DraftSchedule from "../image/Draft Schedule_NATIONALS_SATHYABAMA.docx";
import {
    Box,
    Button,
    Chip,
    Container,
    Drawer,
    Grid,
    IconButton,
    Link,
    Typography
} from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from 'react';
import { eventFlowStyles } from "./styls/frountstyle";

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

// Confetti Component with random positioning
const Confetti = () => {
    const colors = ['#E84393', '#6C5CE7', '#00B894', '#FDCB6E', '#FF7675', '#74B9FF', '#FD79A8'];
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        const newParticles = Array.from({ length: 50 }, (_, i) => ({
            id: i,
            x: Math.random() * 100,
            y: Math.random() * 100,
            color: colors[Math.floor(Math.random() * colors.length)],
            size: Math.random() * 10 + 5,
            duration: Math.random() * 3 + 2,
            delay: Math.random() * 5,
        }));
        setParticles(newParticles);
    }, []);

    return (
        <Box sx={eventFlowStyles.confettiContainer}>
            {particles.map((particle) => (
                <MotionBox
                    key={particle.id}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{
                        opacity: [0, 1, 1, 0],
                        scale: [0, 1, 1, 0],
                        x: [0, Math.random() * 100 - 50],
                        y: [0, Math.random() * 100 - 50],
                        rotate: [0, Math.random() * 360],
                    }}
                    transition={{
                        duration: particle.duration,
                        delay: particle.delay,
                        repeat: Infinity,
                        repeatDelay: Math.random() * 3,
                    }}
                    sx={{
                        position: 'absolute',
                        left: `${particle.x}%`,
                        top: `${particle.y}%`,
                        width: particle.size,
                        height: particle.size,
                        backgroundColor: particle.color,
                        borderRadius: Math.random() > 0.5 ? '50%' : '0%',
                        pointerEvents: 'none',
                    }}
                />
            ))}
        </Box>
    );
};

// Social Media Links
const socialLinks = {
    facebook: "https://www.facebook.com/SathyabamaOfficial/",
    twitter: "https://x.com/sathyabamaSIST",
    instagram: "https://www.instagram.com/sathyabama.official/#",
    youtube: "https://www.youtube.com/channel/UCkBMqT83pxjwPhh8mUpZ0hQ",
};

// Footer Menu Links
const footerMenuLinks = {
    aboutUs: [
        { label: "Vision and Mission", url: "https://www.sathyabama.ac.in/academics/vision-and-mission" },
        { label: "Core Values", url: "https://www.sathyabama.ac.in/core-values" },
        { label: "Overview", url: "https://www.sathyabama.ac.in/about-us" },
        { label: "Founder Chancellor", url: "https://www.sathyabama.ac.in/about-us/founder-chancellor" },
        { label: "Chancellor", url: "https://www.sathyabama.ac.in/about-us/chancellor-president" },
        { label: "Evolution", url: "https://www.sathyabama.ac.in/sathyabama_evolution" },
    ],
    academics: [
        { label: "Programmes Offered", url: "https://www.sathyabama.ac.in/admissions/programs-offered" },
        { label: "Schools", url: "https://www.sathyabama.ac.in/academics/schools" },
        { label: "Faculty", url: "https://www.sathyabama.ac.in/faculty_" },
        { label: "Events", url: "https://www.sathyabama.ac.in/events" },
        { label: "Library", url: "https://www.sathyabama.ac.in/academics/library" },
    ],
    admissions: [
        { label: "Under Graduate", url: "https://www.sathyabama.ac.in/admissions/under-graduate" },
        { label: "Post Graduate", url: "https://www.sathyabama.ac.in/admissions/post-graduate" },
        { label: "Online Learning", url: "https://sist.sathyabama.ac.in/odl/" },
        { label: "FAQ", url: "https://www.sathyabama.ac.in/academics/FAQ" },
    ],
    research: [
        { label: "Ph.D", url: "https://www.sathyabama.ac.in/research/academic-research" },
        { label: "Research Centres", url: "https://www.sathyabama.ac.in/research/centres" },
        { label: "Publications", url: "https://www.sathyabama.ac.in/research/publications" },
        { label: "Patents", url: "https://www.sathyabama.ac.in/Patent" },
    ],
};



const AboutSection = ({ variants }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const highlights = [
        "A National Celebration of Youth, Culture, and Creative Brilliance",
        "Convergence of creativity and intellect",
        "Pan-India cultural celebration involving 100+ universities"
    ];

    const sathyabamaHighlights = [
        "A++ Grade by NAAC",
        "Ranked 53rd among Universities in India (NIRF)",
        "Top 50 for SDG Implementation",
        "ABET Accredited Programmes",
        "Research-intensive university with multiple Centres of Excellence"
    ];

    const aiuHighlights = [
        "Apex Advisory Body on Higher Education",
        "1111 Member Universities",
        "Serving Higher Education for 100 years",
        "Organizing UNIFESTS since 1985",
        "Nodal agency for 40 million youth students"
    ];

    return (
        <MotionBox variants={variants} sx={{ ...eventFlowStyles.contentCard, mt: 3 }}>
            <Typography sx={eventFlowStyles.cardTitle}>About Kalai Saral 2025-26</Typography>

            <Typography sx={{ ...eventFlowStyles.cardText, textAlign: 'justify' }}>
                <strong>Kalai Saral – AIU’s All India Inter-University Youth Festival 2025–26</strong><br />
                Kalai Saral stands as a grand national stage that brings together the finest young talents from universities across India. Steeped in the essence of artistic expression and cultural harmony, the festival is a spirited tribute to the imagination, drive, and limitless potential of today’s youth.
            </Typography>

            <AnimatePresence>
                {isExpanded && (
                    <MotionBox
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Box sx={{ mb: 3, mt: 2 }}>
                            {highlights.map((item, idx) => (
                                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#E84393', flexShrink: 0 }} />
                                    <Typography sx={{ color: '#E84393', fontWeight: 600, fontSize: '0.95rem' }}>{item}</Typography>
                                </Box>
                            ))}
                            <Typography sx={{ ...eventFlowStyles.cardText, textAlign: 'justify', mt: 2 }}>
                                Designed as a convergence of creativity and intellect, Kalai Saral reflects India’s diverse cultural fabric. The festival honours the nation’s heritage while empowering young artists to explore new forms of expression, innovation, and collaboration. As a pan-India cultural celebration, it welcomes participants from every corner of the country, creating a vibrant space where languages, traditions, art forms, and perspectives blend seamlessly.
                            </Typography>
                        </Box>

                        <Box sx={{ mb: 4, pt: 2, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                            <Typography sx={{ ...eventFlowStyles.cardTitle, fontSize: '1.4rem' }}>About Sathyabama</Typography>
                            <Typography sx={{ ...eventFlowStyles.cardText, textAlign: 'justify' }}>
                                Sathyabama Institute of Science and Technology is a prestigious institution that has established a distinguished presence in the fields of engineering, science, and technology for over three successful decades. Founded in 1988 by the visionary Founder Chancellor, Dr. Jeppiaar, the institution has consistently upheld excellence in higher education and research.
                            </Typography>
                            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mt: 2 }}>
                                {sathyabamaHighlights.map((item, idx) => (
                                    <Box key={idx} sx={eventFlowStyles.achievementItem}>
                                        <Box sx={eventFlowStyles.checkIcon}>✓</Box>
                                        <Typography sx={eventFlowStyles.achievementText}>{item}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>

                        <Box sx={{ mb: 2, pt: 2, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                            <Typography sx={{ ...eventFlowStyles.cardTitle, fontSize: '1.4rem' }}>About AIU</Typography>
                            <Typography sx={{ ...eventFlowStyles.cardText, textAlign: 'justify' }}>
                                The Association of Indian Universities (AIU) is an Apex Advisory Body on Higher Education mandated by the Ministry of Education. With about 1111 member Universities, AIU has been serving the Higher Education Sector for the last 100 years.
                            </Typography>
                            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mt: 2 }}>
                                {aiuHighlights.map((item, idx) => (
                                    <Box key={idx} sx={eventFlowStyles.achievementItem}>
                                        <Box sx={{ ...eventFlowStyles.checkIcon, background: 'linear-gradient(135deg, #6C5CE7 0%, #a29bfe 100%)' }}>•</Box>
                                        <Typography sx={eventFlowStyles.achievementText}>{item}</Typography>
                                    </Box>
                                ))}
                            </Box>
                            <Typography sx={{ ...eventFlowStyles.cardText, textAlign: 'justify', mt: 3 }}>
                                AIU has been annually organizing the Inter University Youth Festivals (UNIFESTS) since 1985. These festivals play a significant role in promoting pride in Indian culture and youth identity among the 40 million youth students it serves.
                            </Typography>
                        </Box>
                    </MotionBox>
                )}
            </AnimatePresence>

            <Button
                onClick={() => setIsExpanded(!isExpanded)}
                endIcon={isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                sx={{
                    color: '#E84393',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1rem',
                    mt: 1,
                    '&:hover': { background: 'transparent', textDecoration: 'underline' }
                }}
                disableRipple
            >
                {isExpanded ? "Read Less" : "Read More Details"}
            </Button>
        </MotionBox>
    );
};

const EventFlowHomePage = () => {
    const [activeSection, setActiveSection] = useState("HOME");
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [showInitialContent, setShowInitialContent] = useState(true);
    const contentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMenuClick = (item) => {
        if (item === "HOME") {
            setShowInitialContent(true);
            setActiveSection("HOME");
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            setActiveSection(item);
            setShowInitialContent(false);
            setMobileMenuOpen(false);
            if (contentRef.current) {
                contentRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    };

    const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

    const navItems = [
        { id: 'HOME', label: 'Home', icon: <HomeIcon /> },
        // { id: 'ABOUT', label: 'About', icon: <InfoIcon /> },
        { id: 'INVITATION', label: 'Invitation', icon: <ContactMailIcon /> },
        { id: 'REGISTRATION', label: 'Registration', icon: <HowToRegIcon /> },
        { id: 'EVENTS', label: 'Events', icon: <EventIcon /> },
        { id: 'EVENT SCHEDULE', label: 'Event Schedule', icon: <ScheduleIcon /> },
        { id: 'CAMPUS', label: 'Campus', icon: <LocationOnIcon /> },
        { id: 'DOWNLOADS', label: 'Downloads', icon: <CalendarMonthIcon /> },
        { id: 'GALLERY', label: 'Gallery', icon: <PhotoLibraryIcon /> },
    ];

    const topNavItems = ["HOME", "INVITATION", "REGISTRATION", "EVENTS", "EVENT SCHEDULE", "CAMPUS"];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { staggerChildren: 0.15, delayChildren: 0.1 } }
    };

    const itemVariants = {
        hidden: { y: 30, opacity: 0 },
        visible: { y: 0, opacity: 1, transition: { type: "spring", stiffness: 80 } }
    };

    const cardVariants = {
        hidden: { scale: 0.9, opacity: 0, rotateY: -15 },
        visible: { scale: 1, opacity: 1, rotateY: 0, transition: { type: "spring", stiffness: 100 } },
        hover: { scale: 1.05, y: -10, rotateY: 5, transition: { duration: 0.3 } }
    };

    const slideInFromLeft = {
        hidden: { x: -100, opacity: 0 },
        visible: { x: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const slideInFromRight = {
        hidden: { x: 100, opacity: 0 },
        visible: { x: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const MobileDrawerContent = () => (
        <Box sx={eventFlowStyles.mobileDrawer}>
            <Box sx={eventFlowStyles.mobileDrawerHeader}>
                <img src="./logo.png" alt="Logo" style={{ width: "150px", height: "50px" }} />
                <IconButton onClick={toggleMobileMenu} sx={eventFlowStyles.closeButton}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={eventFlowStyles.mobileDrawerMenu}>
                {navItems.map((item) => (
                    <MotionBox
                        key={item.id}
                        onClick={() => handleMenuClick(item.id)}
                        whileHover={{ x: 10 }}
                        sx={{
                            ...eventFlowStyles.mobileDrawerMenuItem,
                            ...(activeSection === item.id && eventFlowStyles.mobileDrawerMenuItemActive)
                        }}
                    >
                        {item.icon}
                        <Typography sx={{ ml: 2 }}>{item.label}</Typography>
                    </MotionBox>
                ))}
            </Box>
        </Box>
    );

    // Combined HOME and ABOUT content
    const InitialContent = () => (
        <MotionBox variants={containerVariants} initial="hidden" animate="visible">
            {/* Hero Content with Split Layout */}
            <Box sx={eventFlowStyles.heroSplitSection}>
                <MotionBox
                    variants={slideInFromLeft}
                    initial="hidden"
                    animate="visible"
                    sx={eventFlowStyles.heroTextSection}
                >
                    <Typography sx={eventFlowStyles.heroMusicTag}>NATIONAL FESTIVAL</Typography>
                    <Typography sx={eventFlowStyles.heroLargeTitle}>
                        DISCOVER A WORLD<br />
                        <Box component="span" sx={eventFlowStyles.heroOutlineText}>OF CELEBRATION</Box>
                    </Typography>
                    <Typography sx={eventFlowStyles.heroDescription}>
                        Join us for an unforgettable national celebration bringing together the finest young talents from universities across India.
                    </Typography>

                    <Box sx={eventFlowStyles.heroInfoBoxes}>
                        <Box sx={eventFlowStyles.heroInfoItem}>
                            <LocationOnIcon sx={{ color: '#E84393', fontSize: 20 }} />
                            <Typography sx={eventFlowStyles.heroInfoText}>
                                Sathyabama IST, Chennai
                            </Typography>
                        </Box>
                        <Box sx={eventFlowStyles.heroInfoItem}>
                            <EventIcon sx={{ color: '#E84393', fontSize: 20 }} />
                            <Typography sx={eventFlowStyles.heroInfoText}>
                                10-14 March 2026
                            </Typography>
                        </Box>
                    </Box>
                </MotionBox>

                <MotionBox
                    variants={slideInFromRight}
                    initial="hidden"
                    animate="visible"
                    sx={eventFlowStyles.heroImageSection}
                >
                    <Box sx={eventFlowStyles.heroImageFrame}>
                        <Box
                            component="img"
                            src="./b3.jpg"
                            alt="Kalai Saral 2026"
                            sx={eventFlowStyles.heroMainImage}
                        />
                    </Box>
                </MotionBox>
            </Box>

            <Box sx={eventFlowStyles.whyJoinSection}>
                <Typography sx={eventFlowStyles.sectionTitle}>
                    Why Should You Join Our Event
                </Typography>
                <Box sx={eventFlowStyles.featureGrid}>
                    {[
                        { icon: "🎨", title: "Creative Excellence", description: "Showcase your talents on a national platform with world-class facilities and professional event management." },
                        { icon: "🤝", title: "Unique Networking", description: "Connect with talented individuals from universities across India and build lasting relationships." },
                        { icon: "🏆", title: "Event Management", description: "Experience impeccably curated events with guidance from expert judges and mentors." }
                    ].map((feature, idx) => (
                        <MotionBox key={idx} variants={cardVariants} whileHover="hover" sx={eventFlowStyles.featureCard}>
                            <Typography sx={{ fontSize: 48, mb: 2 }}>{feature.icon}</Typography>
                            <Typography sx={eventFlowStyles.featureTitle}>{feature.title}</Typography>
                            <Typography sx={eventFlowStyles.featureDescription}>{feature.description}</Typography>
                        </MotionBox>
                    ))}
                </Box>
            </Box>
            <Box sx={eventFlowStyles.infoSection}>
                <Typography sx={eventFlowStyles.sectionTitle}>Event Information</Typography>
                <Box sx={eventFlowStyles.infoGrid}>
                    {[
                        { icon: <EventIcon sx={{ fontSize: 40 }} />, title: "Event Dates", value: "10th - 14th March 2026", color: "#E84393" },
                        { icon: <LocationOnIcon sx={{ fontSize: 40 }} />, title: "Venue", value: "Sathyabama IST, Chennai", color: "#f50707ff" },
                        { icon: <PeopleIcon sx={{ fontSize: 40 }} />, title: "Categories", value: "28 Events", color: "#00B894" },
                        { icon: <EmojiEventsIcon sx={{ fontSize: 40 }} />, title: "Level", value: "National", color: "#FDCB6E" }
                    ].map((item, idx) => (
                        <MotionBox key={idx} variants={cardVariants} whileHover="hover" sx={eventFlowStyles.infoCard}>
                            <Box sx={{ color: item.color, mb: 2 }}>{item.icon}</Box>
                            <Typography sx={eventFlowStyles.infoCardTitle}>{item.title}</Typography>
                            <Typography sx={eventFlowStyles.infoCardValue}>{item.value}</Typography>
                        </MotionBox>
                    ))}
                </Box>
            </Box>
            <AboutSection variants={itemVariants} />
        </MotionBox>
    );

    const menuContent = {
        INVITATION: (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Invitation</Typography>

                <MotionBox variants={itemVariants} sx={eventFlowStyles.invitationCard}>
                    <Typography sx={eventFlowStyles.invitationTitle}>
                        ✨ You are cordially invited! ✨
                    </Typography>
                    <Typography sx={eventFlowStyles.cardText} paragraph>
                        Dear Participants, Faculty Members, and Esteemed Guests,
                    </Typography>
                    <Typography sx={eventFlowStyles.cardText} paragraph>
                        Sathyabama Institute of Science and Technology, Chennai, Tamil Nadu, is honoured to invite all qualifying universities to participate in the 39th AIU Inter-University National Youth Festival 2025–26, "Kalai Saral", to be held under the aegis of the Association of Indian Universities (AIU), New Delhi.
                    </Typography>
                    <Typography sx={eventFlowStyles.cardText} paragraph>
                        This prestigious national-level cultural event offers a vibrant platform to celebrate creativity, art, culture, and the dynamic spirit of youth.
                    </Typography>

                    <Box sx={eventFlowStyles.eventDetailsBox}>
                        <MotionBox variants={cardVariants} whileHover="hover" sx={eventFlowStyles.eventDetail}>
                            <EventIcon sx={{ fontSize: 32, color: "#E84393" }} />
                            <Typography sx={eventFlowStyles.eventDetailLabel}>Date</Typography>
                            <Typography sx={eventFlowStyles.eventDetailValue}>10-14 March 2026</Typography>
                        </MotionBox>
                        <MotionBox variants={cardVariants} whileHover="hover" sx={eventFlowStyles.eventDetail}>
                            <LocationOnIcon sx={{ fontSize: 32, color: "#6C5CE7" }} />
                            <Typography sx={eventFlowStyles.eventDetailLabel}>Venue</Typography>
                            <Typography sx={eventFlowStyles.eventDetailValue}>Sathyabama IST, Chennai</Typography>
                        </MotionBox>
                    </Box>

                    <Box sx={{ mt: 3 }}>
                        <Typography sx={{ ...eventFlowStyles.cardTitle, mb: 2 }}>Event Categories</Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {["Music", "Dance", "Theatre", "Literary Arts", "Fine Arts"].map((cat, idx) => (
                                <Chip key={idx} label={cat} sx={eventFlowStyles.categoryChip} />
                            ))}
                        </Box>
                    </Box>

                    <Box sx={{ mt: 4, textAlign: 'right' }}>
                        <Typography sx={eventFlowStyles.signatureText}>
                            <strong>Manisha Niraj</strong><br />
                            Executive Head<br />
                            yf.secretary@sathyabama.ac.in<br />
                            Contact: 7200533201
                        </Typography>
                    </Box>
                </MotionBox>
            </MotionBox>
        ),
        REGISTRATION: (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Registration Information</Typography>

                <MotionBox variants={itemVariants} sx={eventFlowStyles.contentCard}>
                    <Typography sx={eventFlowStyles.cardTitle}>📝 Registration Portal</Typography>
                    <Typography sx={eventFlowStyles.cardText} paragraph>
                        The entire registration process will be completed online through the AIU Portal:
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Button
                                variant="contained"
                                fullWidth
                                size="large"
                                href="https://university.aiu.ac.in/UniversityYouthAffair/UniversityLogin"
                                target="_blank"
                                sx={eventFlowStyles.primaryButton}
                            >
                                Access Registration Portal
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Button
                                variant="contained"
                                fullWidth
                                size="large"
                                href={RegistrationGuidelines}
                                download="Registration_Guidelines.pdf"
                                startIcon={<DownloadIcon />}
                                sx={{ ...eventFlowStyles.primaryButton, background: 'linear-gradient(45deg, #6C5CE7 30%, #a29bfe 90%)' }}
                            >
                                Download Registration Guidelines
                            </Button>
                        </Grid>
                    </Grid>
                </MotionBox>

                <Box sx={eventFlowStyles.registrationGrid}>
                    <MotionBox variants={cardVariants} whileHover="hover" sx={eventFlowStyles.contentCard}>
                        <Typography sx={eventFlowStyles.cardTitle}>📅 Important Dates</Typography>
                        <Box sx={eventFlowStyles.dateBox}>
                            <Typography sx={eventFlowStyles.dateLabel}>Registration Closes</Typography>
                            <Typography sx={eventFlowStyles.dateValue}>20 February 2026</Typography>
                        </Box>
                        <Box sx={{ ...eventFlowStyles.dateBox, mt: 2 }}>
                            <Typography sx={eventFlowStyles.dateLabel}>Festival Dates</Typography>
                            <Typography sx={eventFlowStyles.dateValue}>10-14 March 2026</Typography>
                        </Box>
                    </MotionBox>

                    <MotionBox variants={cardVariants} whileHover="hover" sx={eventFlowStyles.contentCard}>
                        <Typography sx={eventFlowStyles.cardTitle}>💰 Fee Structure</Typography>
                        <Box sx={eventFlowStyles.feeBox}>
                            <Typography sx={eventFlowStyles.feeAmount}>₹3,500</Typography>
                            <Typography sx={eventFlowStyles.feeLabel}>Per Participant</Typography>
                        </Box>
                        <Box sx={{ ...eventFlowStyles.feeBox, mt: 2 }}>
                            <Typography sx={eventFlowStyles.feeAmount}>₹5,000</Typography>
                            <Typography sx={eventFlowStyles.feeLabel}>Caution Money (Refundable)</Typography>
                        </Box>
                    </MotionBox>
                </Box>

                <MotionBox variants={itemVariants} sx={{ ...eventFlowStyles.contentCard, mt: 3 }}>
                    <Typography sx={eventFlowStyles.cardTitle}>🏦 Payment Details</Typography>
                    <Box sx={eventFlowStyles.paymentDetails}>
                        {[
                            { label: "Account Name:", value: "Youth Festival Sathyabama IST" },
                            { label: "Account Number:", value: "8138087818" },
                            { label: "Bank:", value: "Indian Bank" },
                            { label: "IFSC Code:", value: "IDIB000S201" },
                            { label: "Branch:", value: "Sathyabama University ,Rajiv Gandhi Salai ,Chennai 600 119" },
                            { label: "MICR Code:", value: "600019229" },
                            { label: "IFSC Code:", value: "IDIB000S201" },
                        ].map((item, idx) => (
                            <MotionBox key={idx} variants={itemVariants} sx={eventFlowStyles.paymentItem}>
                                <Typography sx={eventFlowStyles.paymentLabel}>{item.label}</Typography>
                                <Typography sx={eventFlowStyles.paymentValue}>{item.value}</Typography>
                            </MotionBox>
                        ))}
                    </Box>
                </MotionBox>

                <MotionBox variants={itemVariants} sx={{ ...eventFlowStyles.contentCard, mt: 3 }}>
                    <Typography sx={eventFlowStyles.cardTitle}>👥 Contingent Details</Typography>
                    <Typography sx={eventFlowStyles.cardText} paragraph>
                        Maximum contingent strength: <strong>60 members</strong> including:
                    </Typography>
                    <Box sx={eventFlowStyles.listItems}>
                        {[
                            "1 Dean/Director or equivalent representative",
                            "2 Team Managers (preferably one male and one female)",
                            "Student participants",
                            "Student accompanists",
                            "Professional accompanists"
                        ].map((item, idx) => (
                            <MotionBox key={idx} variants={itemVariants} sx={eventFlowStyles.listItem}>
                                <Box sx={eventFlowStyles.listBullet}>•</Box>
                                <Typography sx={eventFlowStyles.listText}>{item}</Typography>
                            </MotionBox>
                        ))}
                    </Box>
                </MotionBox>
            </MotionBox>
        ),
        EVENTS: (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Event Categories</Typography>

                <Box sx={eventFlowStyles.eventsGrid}>
                    {[
                        { icon: "🎵", title: "Music Events", count: "9 Events", color: "#E84393", items: ["Classical Vocal Solo(Hindustani or Karnataka)", "Classical Instrunmental Solo(Percussion)", "Classical Instrunmental Solo(Non Percussion)", "Light Vocal (Indian)", "Western Vocal (Solo)", "Group Song (Indian)", "Group Song (Western)", "Folk Orchestra", "Western Instrumental (Solo)"] },
                        { icon: "💃", title: "Dance Events", count: "3 Events", color: "#6C5CE7", items: ["Folk/Tribal Dance", "Classical Dance (Indian)", "Creative Choreography"] },
                        { icon: "🎭", title: "Theatre", count: "4 Events", color: "#00B894", items: ["One Act Play", "Skit", "Mime", "Mimicry"] },
                        { icon: "📚", title: "Literary Arts", count: "5 Events", color: "#FDCB6E", items: ["General Quiz", "Elocution (English)", "Elocution (Hindi)", "Debate (English)", "Debate (Hindi)"] },
                        { icon: "🎨", title: "Fine Arts", count: "6 Events", color: "#FF7675", items: ["On the Spot Painting", "Collage", "Poster Making", "Clay Modelling", "Cartooning", "Rangoli"] },
                        { icon: "🚩", title: "Special Event", count: "1 Event", color: "#A29BFE", items: ["Cultural Procession"] }
                    ].map((category, idx) => (
                        <MotionBox key={idx} variants={cardVariants} whileHover="hover" sx={eventFlowStyles.eventCategoryCard}>
                            <Typography sx={{ fontSize: 64, textAlign: 'center', mb: 2 }}>{category.icon}</Typography>
                            <Typography sx={{ ...eventFlowStyles.eventCategoryTitle, color: category.color }}>
                                {category.title}
                            </Typography>
                            <Typography sx={eventFlowStyles.eventCategoryCount}>{category.count}</Typography>
                            <Box sx={eventFlowStyles.eventsList}>
                                {category.items.map((item, i) => (
                                    <Box key={i} sx={eventFlowStyles.eventItem}>
                                        <Box sx={{ ...eventFlowStyles.eventDot, bgcolor: category.color }} />
                                        <Typography sx={eventFlowStyles.eventName}>{item}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </MotionBox>
                    ))}
                </Box>
            </MotionBox>
        ),
        "EVENT SCHEDULE": (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Event Schedule</Typography>
                <Typography sx={{ ...eventFlowStyles.cardText, textAlign: 'center', mb: 4 }}>
                    The journey to the National Festival begins with Zonal competitions across India
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                    <Button
                        variant="contained"
                        href={DraftSchedule}
                        download="Draft Schedule_NATIONALS_SATHYABAMA.docx"
                        startIcon={<DownloadIcon />}
                        sx={{ ...eventFlowStyles.primaryButton, background: 'linear-gradient(45deg, #FF7675 30%, #fab1a0 90%)' }}
                    >
                        Download National Fest Schedule
                    </Button>
                </Box>

                <Box sx={eventFlowStyles.scheduleList}>
                    {[
                        { zone: "Central Zone", dates: "25-29 November 2025", university: "MGM University", location: "Maharashtra", contact: "Dr Shivdarshan Kadam: 9823745745", color: "#E84393" },
                        { zone: "North East Zone", dates: "15-19 December 2025", university: "Assam Don Bosco University", location: "Guwahati, Assam", contact: "Dr Alpana Choudhury: 9954708001", color: "#6C5CE7" },
                        { zone: "South Zone", dates: "19-23 December 2025", university: "Hindustan Institute", location: "Chennai, Tamil Nadu", contact: "Dr. K. S. Shaji: 9080830983", color: "#00B894" },
                        { zone: "North Zone", dates: "6-10 January 2026", university: "Chitkara University", location: "Punjab", contact: "Dr. Neelam Verma: 09501105607", color: "#FDCB6E" },
                        { zone: "East Zone", dates: "27-31 January 2026", university: "Fakir Mohan University", location: "Balasore, Odisha", contact: "Dr Asim Amitabh Pradhan: 9437991091", color: "#FF7675" },
                        { zone: "North Central Zone", dates: "03-07 February 2026", university: "Maharishi Markandeshwar University", location: "Haryana", contact: "Sh. Deepak Kumar Jha: 9464108712", color: "#A29BFE" },
                        { zone: "South West Zone", dates: "09-13 February 2026", university: "JSS Academy", location: "Mysuru, Karnataka", contact: "Dr. Vishal Kumar Gupta: 92421 57508", color: "#FD79A8" },
                        { zone: "West Zone", dates: "11-15 February 2026", university: "CVM University", location: "Anand, Gujarat", contact: "Prof. Sandeep K Walia: 9418300551", color: "#74B9FF" }
                    ].map((schedule, idx) => (
                        <MotionBox key={idx} variants={itemVariants} whileHover={{ x: 10 }} sx={eventFlowStyles.scheduleCard}>
                            <Box sx={{ ...eventFlowStyles.scheduleAccent, bgcolor: schedule.color }} />
                            <Box sx={eventFlowStyles.scheduleContent}>
                                <Typography sx={{ ...eventFlowStyles.scheduleZone, color: schedule.color }}>
                                    {schedule.zone}
                                </Typography>
                                <Typography sx={eventFlowStyles.scheduleUniversity}>{schedule.university}</Typography>
                                <Typography sx={eventFlowStyles.scheduleLocation}>📍 {schedule.location}</Typography>
                                <Typography sx={eventFlowStyles.scheduleContact}>📞 {schedule.contact}</Typography>
                            </Box>
                            <Box sx={eventFlowStyles.scheduleDateBox}>
                                <Typography sx={eventFlowStyles.scheduleDates}>{schedule.dates}</Typography>
                            </Box>
                        </MotionBox>
                    ))}
                </Box>

                <MotionBox variants={itemVariants} sx={eventFlowStyles.nationalEventCard}>
                    <Typography sx={eventFlowStyles.nationalEventTitle}>
                        🏆 AIU National Youth Festival
                    </Typography>
                    <Typography sx={eventFlowStyles.nationalEventSubtitle}>KALAI SARAL</Typography>
                    <Typography sx={eventFlowStyles.nationalEventDate}>10-14 March 2026</Typography>
                    <Typography sx={eventFlowStyles.nationalEventVenue}>
                        Sathyabama Institute of Science and Technology, Chennai
                    </Typography>
                </MotionBox>
            </MotionBox>
        ),
        CAMPUS: (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Campus Information</Typography>

                <MotionBox variants={itemVariants} sx={eventFlowStyles.contentCard}>
                    <Typography sx={eventFlowStyles.cardTitle}>🏛️ Sathyabama Institute of Science and Technology</Typography>
                    <Typography sx={eventFlowStyles.cardText}>
                        Established in 1988, Sathyabama is a premier institution offering world-class infrastructure and facilities for hosting large-scale national events.
                    </Typography>
                </MotionBox>

                <Box sx={eventFlowStyles.campusGrid}>
                    {[
                        { icon: <LocationOnIcon sx={{ fontSize: 48 }} />, title: "Location", info: ["Jeppiaar Nagar, OMR", "Chennai 600119"], color: "#E84393", link: "https://maps.app.goo.gl/Ti4bhtiwhWU5svsP8" },
                        { icon: "✈️", title: "From Airport", info: ["Approx. 30 km", "Chennai International Airport"], color: "#6C5CE7" },
                        { icon: "🚂", title: "From Railway", info: ["Tambaram Railway Station (18 km)", "Velachery MRTS Station(15 km)"], color: "#00B894" }
                    ].map((item, idx) => (
                        <MotionBox
                            key={idx}
                            variants={cardVariants}
                            whileHover="hover"
                            sx={{
                                ...eventFlowStyles.campusCard,
                                cursor: item.link ? 'pointer' : 'default'
                            }}
                            onClick={() => item.link && window.open(item.link, '_blank')}
                        >
                            <Box sx={{ fontSize: 48, color: item.color, mb: 2, textAlign: 'center' }}>{item.icon}</Box>
                            <Typography sx={{ ...eventFlowStyles.campusCardTitle, color: item.color }}>{item.title}</Typography>
                            {item.info.map((text, i) => (
                                <Typography key={i} sx={eventFlowStyles.campusCardText}>{text}</Typography>
                            ))}
                            {item.link && (
                                <Typography sx={{ fontSize: '0.8rem', color: item.color, mt: 1, fontWeight: 'bold', textAlign: 'center' }}>
                                    (Click Me)
                                </Typography>
                            )}
                        </MotionBox>
                    ))}
                </Box>

                <MotionBox variants={itemVariants} sx={{ ...eventFlowStyles.contentCard, mt: 3 }}>
                    <Typography sx={eventFlowStyles.cardTitle}>🏨 Accommodation & Food</Typography>
                    <Typography sx={eventFlowStyles.cardText}>
                        <strong>Free board and lodging</strong> will be provided to all participating teams during the festival. Accommodation starts from the night before the fest begins until the morning after the valedictory ceremony.
                    </Typography>
                    <Typography sx={eventFlowStyles.cardText}>
                        <strong>Collect From Registration Desk :</strong>
                        <br />
                        <Typography sx={eventFlowStyles.cardText}>
                            . Fest ID card / Gate Pass
                            <br />
                            . Food Coupons
                        </Typography>
                    </Typography>
                </MotionBox>
            </MotionBox>
        ),
        DOWNLOADS: (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Downloads</Typography>

                <Box sx={eventFlowStyles.downloadsGrid}>
                    {[
                        { title: "📄 Essential Documents", items: ["Official Brochure (PDF)", "Rules and Regulations", "Event Guidelines", "Participation Form"] },
                        { title: "📋 Registration Materials", items: ["Annexure I: Team Registration", "Annexure II: Team Details", "Annexure III: Event List", "Annexure IV: Event-Wise"] },
                        { title: "🏛️ Campus Information", items: ["Campus Map", "Accommodation Details", "Travel Information", "Tourist Attractions"] },
                        { title: "📱 Contact Information", items: ["Coordinators List", "Event Coordinators", "Emergency Contacts", "Technical Support"] }
                    ].map((section, idx) => (
                        <MotionBox key={idx} variants={cardVariants} whileHover="hover" sx={eventFlowStyles.downloadCard}>
                            <Typography sx={eventFlowStyles.downloadTitle}>{section.title}</Typography>
                            <Box sx={eventFlowStyles.downloadList}>
                                {section.items.map((item, i) => (
                                    <Box key={i} sx={eventFlowStyles.downloadItem}>
                                        <Typography sx={eventFlowStyles.downloadItemText}>📥 {item}</Typography>
                                        <Link href="#" sx={eventFlowStyles.downloadLink}>Download</Link>
                                    </Box>
                                ))}
                            </Box>
                        </MotionBox>
                    ))}
                </Box>
            </MotionBox>
        ),
        GALLERY: (
            <MotionBox variants={containerVariants} initial="hidden" animate="visible">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => handleMenuClick('HOME')}
                    sx={eventFlowStyles.backButton}
                >
                    Back to Home
                </Button>

                <Typography sx={eventFlowStyles.pageTitle}>Gallery</Typography>

                <MotionBox variants={itemVariants} sx={eventFlowStyles.contentCard}>
                    <Typography sx={eventFlowStyles.cardText}>
                        Explore moments from previous AIU Youth Festivals and get a glimpse of the vibrant cultural celebrations that await at Kalai Saral 2026!
                    </Typography>
                </MotionBox>

                <Box sx={eventFlowStyles.galleryGrid}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                        <MotionBox
                            key={num}
                            variants={cardVariants}
                            whileHover={{ scale: 1.1, rotate: 5 }}
                            sx={eventFlowStyles.galleryItem}
                        >
                            <Typography sx={eventFlowStyles.galleryNumber}>Gallery {num}</Typography>
                        </MotionBox>
                    ))}
                </Box>

                <MotionBox variants={itemVariants} sx={{ ...eventFlowStyles.contentCard, mt: 4, textAlign: 'center' }}>
                    <Typography sx={{ ...eventFlowStyles.cardTitle, mb: 3 }}>📱 Follow Us on Social Media</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                        {[
                            { tag: "#KalaiSaral2026", color: "#E84393" },
                            { tag: "#AIUYouthFest", color: "#6C5CE7" },
                            { tag: "#SathyabamaIST", color: "#00B894" }
                        ].map((item, idx) => (
                            <Chip key={idx} label={item.tag} sx={{ ...eventFlowStyles.hashtagChip, bgcolor: `${item.color}30`, color: item.color, borderColor: item.color }} />
                        ))}
                    </Box>
                </MotionBox>
            </MotionBox>
        ),
    };

    return (
        <Box sx={eventFlowStyles.root}>
            <Confetti />

            <Drawer
                anchor="left"
                open={mobileMenuOpen}
                onClose={toggleMobileMenu}
                sx={{ "& .MuiDrawer-paper": { width: "280px", bgcolor: "#0F0F23" } }}
            >
                <MobileDrawerContent />
            </Drawer>

            {/* Improved Header matching reference */}
            <Box sx={{ ...eventFlowStyles.header, ...(scrolled && eventFlowStyles.headerScrolled) }}>
                <Container maxWidth="xl">
                    <Box sx={eventFlowStyles.headerContent}>
                        {/* Mobile Menu */}
                        <IconButton onClick={toggleMobileMenu} sx={{ ...eventFlowStyles.menuButton, display: { xs: 'flex', md: 'none' } }}>
                            <MenuIcon />
                        </IconButton>

                        {/* Logo */}
                        <Box sx={eventFlowStyles.logo} onClick={() => handleMenuClick('HOME')}>
                            <img src="./logo.png" alt="Logo" style={{ height: '70px', width: 'auto' }} />
                        </Box>

                        {/* Desktop Navigation */}
                        <Box sx={{ ...eventFlowStyles.desktopNav, display: { xs: 'none', md: 'flex' } }}>
                            {topNavItems.map((item) => (
                                <Button
                                    key={item}
                                    onClick={() => handleMenuClick(item)}
                                    sx={{
                                        ...eventFlowStyles.navButton,
                                        ...(activeSection === item && eventFlowStyles.navButtonActive)
                                    }}
                                >
                                    {item}
                                </Button>
                            ))}
                        </Box>

                        {/* Header Action Icons */}
                        <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 1, alignItems: 'center' }}>
                            <img src="./f1.png" alt="Header Icon" style={{ height: '100px', width: 'auto' }} />
                        </Box>
                    </Box>
                </Container>
            </Box>

            {/* Main Content */}
            <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
                <Box ref={contentRef}>
                    <AnimatePresence mode="wait">
                        {showInitialContent ? (
                            <InitialContent />
                        ) : (
                            <MotionBox
                                key={activeSection}
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.95 }}
                                transition={{ duration: 0.4 }}
                            >
                                {menuContent[activeSection]}
                            </MotionBox>
                        )}
                    </AnimatePresence>
                </Box>
            </Container>

            {/* Footer */}
            <Box sx={eventFlowStyles.footer}>
                <Container maxWidth="xl">
                    <Box sx={eventFlowStyles.footerContent}>
                        <Box sx={eventFlowStyles.footerSection}>
                            <img src="./logo.png" alt="Logo" style={{ maxWidth: "200px", height: "auto", marginBottom: "16px" }} />
                            <Typography sx={eventFlowStyles.footerText}>Jeppiaar Nagar, SH 49A</Typography>
                            <Typography sx={eventFlowStyles.footerText}>Chennai, Tamil Nadu 600119</Typography>
                            <Typography sx={eventFlowStyles.footerText}>📧 yf.secretary@sathyabama.ac.in</Typography>
                            <Typography sx={eventFlowStyles.footerText}>📞 7200533201</Typography>

                            <Box sx={{ display: "flex", gap: 1, mt: 3 }}>
                                {[
                                    { icon: <FacebookIcon />, link: socialLinks.facebook },
                                    { icon: <XIcon />, link: socialLinks.twitter },
                                    { icon: <InstagramIcon />, link: socialLinks.instagram },
                                    { icon: <YouTubeIcon />, link: socialLinks.youtube }
                                ].map((social, idx) => (
                                    <IconButton key={idx} component="a" href={social.link} target="_blank" sx={eventFlowStyles.socialIcon}>
                                        {social.icon}
                                    </IconButton>
                                ))}
                            </Box>
                        </Box>

                        {Object.entries(footerMenuLinks).map(([key, links]) => (
                            <Box key={key} sx={eventFlowStyles.footerSection}>
                                <Typography sx={eventFlowStyles.footerTitle}>
                                    {key === 'aboutUs' ? 'About Us' : key.charAt(0).toUpperCase() + key.slice(1)}
                                </Typography>
                                {links.slice(0, 6).map((link, idx) => (
                                    <Link key={idx} href={link.url} target="_blank" sx={eventFlowStyles.footerLink}>
                                        {link.label}
                                    </Link>
                                ))}
                            </Box>
                        ))}
                    </Box>

                    <Box sx={eventFlowStyles.footerBottom}>
                        <Typography sx={eventFlowStyles.footerCopyright}>
                            © 2026 Sathyabama Institute of Science and Technology. All Rights Reserved
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default EventFlowHomePage;